<template>
	<div id="header">
		<div class="nav-global">
			<div class="container">
				<h1 class="nav-logo">
						<a href="javascript:;"></a>
					</h1>
				<h1 class="nav-title">沈阳驰冠科技有限公司</h1>
				<!--<ul class="nav-aside">
						<li class="nav-user">
							<a href="javascript:;">个人中心</a>
							
							<div class="nav-user-wrapper">
								<div class="nav-user-list">
									<dl class="nav-user-avatar">
										<dd><span class="ng-scope"></span></dd>
										<dt class="ng-binding">+86 138****9453</dt>
									</dl>
									<ul>
										<li class="order"><a href="javascript:;">我的订单</a></li>
										<li class="support"><a href="javascript:;">售后服务</a></li>
										<li class="coupon"><a href="javascript:;">我的优惠</a></li>
										<li class="information"><a href="javascript:;">账户资料</a></li>
										<li class="address"><a href="javascript:;">收货地址</a></li>
										<li class="logout"><a href="javascript:;">退出</a></li>
									</ul>
								</div>
							</div>
						</li>
					</ul>-->
				<ul class="nav-list">					
					<li class="hobby1">
						<!--<a href="javascript:;">文档中心</a>-->
						<router-link to="/download">文档中心</router-link>
					</li>
					<!--<li class="hobby1">
						<a href="javascript:;">应用下载</a>
					</li>-->
					<!--<li class="hobby1">
						<a href="javascript:;">论坛</a>
					</li>-->
					<li class="hobby1">						
						<router-link to="/contact">联系我们</router-link>
					</li>
				</ul>
			</div>
		</div>
		<div class="nav-sub">
			<div class="nav-sub-wrapper">
				<div class="container">
					<ul class="nav-list">
						<li class="hobby active">
							<router-link to='/home'>首页</router-link>
						</li>
						<li class="hobby">
							<router-link to='/remotekey'>远程4G钥匙</router-link>
						</li>
						<li class="hobby">
							<router-link to='/blekey'>蓝牙钥匙</router-link>
						</li>
						<li class="hobby">
							<router-link to='/passlock'>无源电子锁</router-link>
						</li>												
						<!--<li class="hobby">
							<router-link to='/controller'>NB控制器</router-link>
						</li>	-->
						<li class="hobby">
							<router-link to='/valve'>阀门电子锁</router-link>
						</li>
						<li class="hobby">
							<router-link to='/software'>管理软件</router-link>
						</li>						
						<li class="hobby">
							<router-link to='/develop'>产品开发</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	$(function() {
		console.log('jquery ok');
	});

	import carPanel from './car-panel'

	export default {
		data() {
			return {
				isActive: false
			}
		},
		mounted() {
			$('.hobby').on('click', function() {
				console.log('click')
				$('.hobby1').removeClass('active1');
				$(this).addClass('active');
				$(this).siblings().removeClass('active');
			});
			
			$('.hobby1').on('click', function() {
				console.log('click1')
				$('.hobby').removeClass('active');
				$(this).addClass('active1');
				$(this).siblings().removeClass('active1');
			});
		},

		components: {
			carPanel
		},
		methods: {
			add: function() {
				this.isActive = true
				console.log(this.isActive)
			},
			del: function() {
				this.isActive = false
				console.log(this.isActive)
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/header-nav.vue